const randomize = require("randomatic");

export default [
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "username_contains",
      label: "Username",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "user_email_contains",
      label: "User Email",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    main: true,
    props: {
      filterName: "agent_name_contains",
      label: "Agent Name",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () =>
      import("../../shared/list-filters/UserAccessSettingGroupNameFilter"),
    props: {
      filterName: "group_names_eq",
      label: "Group Names",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () =>
      import("../../shared/list-filters/UserAccessSettingNameFilter"),
    props: {
      filterName: "setting_names_eq",
      label: "Setting Names",
    },
  },
];



// WEBPACK FOOTER //
// ./src/components/gt/plugins/user-access-settings/access-settings-filter.js